import { render, staticRenderFns } from "./PhotoStep.vue?vue&type=template&id=647980b4&scoped=true"
import script from "./PhotoStep.vue?vue&type=script&lang=js"
export * from "./PhotoStep.vue?vue&type=script&lang=js"
import style0 from "./PhotoStep.vue?vue&type=style&index=0&id=647980b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647980b4",
  null
  
)

export default component.exports